module.exports = __webpack_public_path__ + "assets/images/action24-2.4e503dbb1277fe8b81c68f45f9b0e133.png";